<template>
  <div id="page-forms">
    <v-form
      v-model="form.valid"
      ref="entryform"
      lazy-validation
    >
      <v-container fluid>
        <v-layout
          row
          wrap
        >
          <p>General Informations</p>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              slot="activator"
              v-model="form.date"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >

            <v-text-field
              label="Login User"
              prepend-icon="person"
              readonly
              name="user"
              v-model="form.loginUser"
            >
            </v-text-field>

          </v-flex>
          <v-flex
            lg1
            sm2
          ></v-flex>
          <v-flex
            lg3
            sm2
          >
            <p>
              <v-icon>verified_user</v-icon>&nbsp;&nbsp;Is this your name?
            </p>
            <v-radio-group
              v-model="form.isLogin"
              row
            >
              <v-radio
                label="Yes"
                value="yes-1"
                color="primary"
              ></v-radio>
              <v-radio
                @click="authUser"
                label="No"
                value="No-1"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <p>Production Order Details</p>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm4
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :search-input.sync="search1"
              editable
              flat
              placeholder="Select only suggested Production Order"
              :items="prodOrders"
              v-model="form.prodOrderNo"
              label="Production Order"
              chips
              @change="getProdLines"
              :loading="loader"
              prepend-icon="drag_indicator"
              required
              item-text="no"
              item-value="no"
              :rules="form.requiredfield"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  class="chip--select-multi"
                >
                  {{ data.item.no }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>

                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.no"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.description"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-autocomplete
              hint="Atleast 3 Characters required"
              :search-input.sync="search2"
              :loading="loader"
              editable
              flat
              placeholder="Select only suggested Prod Line No."
              :items="prodLines"
              v-model="form.prodLineNo"
              label="Prod Line No."
              @change="ChangeProdLine"
              chips
              prepend-icon="theaters"
              required
              item-text="item_No"
              item-value="line_No"
              :rules="form.requiredfield"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  class="chip--select-multi"
                >
                  {{ data.item.line_No }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>

                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.item_No"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.line_No"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Source Item"
              prepend-icon="list"
              name="user"
              v-model="form.sourceItemNo"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Item Description"
              prepend-icon="description"
              name="user"
              v-model="form.itemDescription"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Batch No."
              prepend-icon="developer_board"
              name="user"
              v-model="form.batchNo"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-text-field
              label="Blister BOM"
              prepend-icon="blur_linear"
              name="user"
              v-model="form.blisterBom"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>

        </v-layout>
        <v-layout
          row
          wrap
        >
          <p>
            Scrap Informations
          </p>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            lg4
            sm4
          >
            <v-autocomplete             
              hint="Atleast 3 Characters required"              
              :loading="loader"              
              flat
              placeholder="Select only suggested Plastic bag"
              :items="plasticbags"
              v-model="form.plasticBagID"
              label="Select Plastic bag"
              auto
              chips
              prepend-icon="track_changes"
              required
              item-text="name"
              item-value="plasticBagID"
              :rules="form.requiredfield"
            ></v-autocomplete>

          </v-flex>
          <v-flex
            lg4
            sm4
          >
            <v-autocomplete             
              hint="Atleast 3 Characters required"              
              :loading="loader"              
              flat
              placeholder="Select only suggested Type of blister scrap"
              :items="blisterType"
              v-model="form.blisterScrapTypeID"
              label="Type of blister scrap"
              auto
              chips
              prepend-icon="cancel_presentation"
              required
              item-text="name"
              item-value="scrapCodeID"
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg2
            sm2
          >
            <v-text-field
              label="Weight(KG)"
              prepend-icon="ballot"
              name="name"
              type="number"
              v-model="form.weight"
              suffix="KG"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
 <script>
import { getProdOrderLines } from '@/api/navService';
export default {
  components: {

  },

  data: () => ({
    saveCard: true,
    menus: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],
    items: [
      { title: 'Please place the item(Per beg) on weighing machine.' },
      { title: 'Video on procedure' },
      { title: 'How to operate weighing machine' }
    ],
    blisterType: [],
    prodLines: [],
    plasticbags: [],
    prodOrders: [],
    valid: true,
    loader: false,

    form: {
      valid: false,
      scrapEntryId: -1,
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      prodOrderNo: '',
      prodLineNo: null,
      sourceItemNo: '',
      itemDescription: '',
      batchNo: '',
      blisterBom: '',
      plasticBag: -1,
      plasticBagID: -1,
      blisterScrapTypeID: -1,
      blisterScrapType: -1,
      weight: '',
      addedByUserID: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
    },
  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },
  created () {

    this.initialize();

  },
  methods: {
    getProdLines (item) {
      if (item != '') {
        this.loader = true;
        getProdOrderLines(item)
          .then(response => {
            this.prodLines = response.data;
            this.loader = false;
            this.form.prodLineNo = null;
            this.form.sourceItemNo = '';
            this.form.itemDescription = '';
            this.form.batchNo = '';
          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
    },
    initialize () {

    },
    authUser: function () {
      this.$router.push({ path: '/' });
    },
    ChangeProdLine (value) {
      if (value != '') {
        let prod = this.prodLines.filter(f => f.line_No == value);
        this.form.sourceItemNo = prod[0].item_No;
        this.form.itemDescription = prod[0].description;
        this.form.batchNo = prod[0].batch_No;
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/BlisterScrapEntry.vue